<template>
 <div id="platformInformation-view" class="minHeight">
   <section class="section-1">
     <i-title :titleOne="'平台信息'" :titleTwo="'了解清楚基本信息，避免多走弯路'"></i-title>
     <table class="content-table">
        <tr v-for="(item, index) in list" v-bind:key="index">
          <td>{{item.title}}</td>
          <td>{{item.content}}
            <router-link to="/download.htm" target="_blank" v-if="index === 3">&lt;了解更多&gt;</router-link>
            <router-link to="/companyMessage/privacyClause.htm" target="_blank" v-if="index === 6">&lt;了解更多&gt;</router-link>
            <img src="../../assets/images/wx-copy.png" alt="" v-if="index === 9">
            <a :href="require('../../assets/images/knowNewBank.png')" target="_blank" v-if="index === 5">&lt;存管协议&gt;<img src="../../assets/images/knowNewBank.png"></a>
          </td>
        </tr>
     </table>
   </section>
   <autograph></autograph>
 </div>
</template>

<script>
import autograph from '@/components/autograph'
import informationTitle from '@/components/informationTitle'
export default {
  data () {
    return {
      list: [
        {
          title: '平台名称',
          content: '普惠理财'
        }, {
          title: '网址或平台地址',
          content: 'www.puhuilicai.com'
        }, {
          title: '平台上线运营时间',
          content: '2014年10月08日'
        }, {
          title: '移动APP应用',
          content: '普惠理财-新网银行存管版'
        }, {
          title: '当前经营场所',
          content: '北京市石景山区苹果园路28号院前海人寿大厦B座13层'
        }, {
          title: '资金存管情况',
          content: '新网银行资金存管'
        }, {
          title: '注册协议模板',
          content: '普惠理财用户隐私条款'
        }, {
          title: '相应电信业务经营许可信息',
          content: '京ICP备14042685号-1'
        }, {
          title: '官方微博',
          content: '普惠理财'
        }, {
          title: '公众号或服务号',
          content: '普惠理财(puhuilicai)公众号'
        }
      ]
    }
  },
  mounted () {
    this.verifyLogin().then((res) => {}).catch(() => {})
  },
  methods: {
  },
  components: {
    'autograph': autograph,
    'i-title': informationTitle
  }
}
</script>

<style lang="less">
#platformInformation-view{
  width:980px;
  float: left;
  overflow: hidden;
  background: #fff;
  margin-left: 20px;
  margin-bottom: 20px;
  position: relative;
  .section-1{
    margin-bottom: 100px;
    .content-table{
      width: 780px;
      margin:0 auto;
      tr{
        &:hover{
          background: #F7FCFF;
        }
        td{
          border:1px solid #eee;
          padding:12px 0;
          padding-left: 50px;
          font-size: 14px;
          color: #323232;
          a{
            color: #6396eb;
            padding-left: 30px;
            img{
              display: inline-block;
              width: 0;
              height: 0;
            }
          }
          img{
            display: block;
          }
        }
        td:first-child{
          color: #5e5e5e;
          vertical-align: baseline;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/information/platformInformation.vue